import React, {useRef, useState} from "react";
import Floaticons from "../../Floaticons";
import MenuNavbar from "../../MenuNavbar";
import { NavLink } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import * as XLSX from "xlsx";
import ClipLoader from 'react-spinners/ClipLoader'; // import the spinner
import AddIcon from "@mui/icons-material/Add";
import baseUrl from "../../../utils/Constants";
import axios from 'axios';
import './SecuritySpecialization.css';
import './InnerTabCommonStyles.css'
import './AccordianStyles.css'
import './TabContentStyles.css'
import SSAcardsData from '../../Data/SecuritySpecializationNew/SSAMainCardData.json';

function SecuritySpecialization() {

    const fileInputRef = useRef(null);
    const [alldata, setalldata] = useState();
    const [confirmationPopup, setconfirmationPopup] = useState(false);
    const [filename, setfilename] = useState();
    const [loading, setLoading] = useState(false); // Loader state
    const [courseToUpload, setcourseToUpload] = useState([]);
    const allowedPeople = [
        "h.srinivasan", "s.a.thiruveedhula", "mamta.thakur", "ankita.rawat.garg", "aluru.akash", "varsha.a.tyagi", "shriya.jaswani", "sunil.l.singh"
    ];
    //fetching User

    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();

    let loggedInEnterpriseId = "";
    if (activeAccount)
        loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;

    const convertToJSON = (rows) => {
        const headers = rows[0];             // First row = headers
        const dataRows = rows.slice(1);      // Remaining rows = data
 
        const json = dataRows.map(row => {
            let obj = {};
            headers.forEach((header, index) => {
                const key = header.replace(/\s+/g, '_').toLowerCase();
                obj[key] = row[index] ? row[index] : "";
            });

            return obj;
        });
        console.log("jsondata", json);

        return json;
    };

    const handleButtonClick = () => {
        fileInputRef.current.click();
    }

    const addFilteredData = async (data, routeName) => {
        const response = await axios.post(`${baseUrl}/${routeName}`, data, {
            headers: {
                "Content-Type": "application/json",
                Authorization: localStorage.getItem("token")
            }
        }
        ).then(res => {
            // toast.success("Data added successfully!")
            console.log("sucesss shriya");
            
        }).catch(err => console.log("failed"))

    }

    const filterAndPostData = ( coursesToUpload ) => {

        let startegy = [];
        let protection = [];
        let resilience = [];
        let physicalSec = [];

        startegy = coursesToUpload.filter((course) => course.practice?.includes("Strategy"));
        protection = coursesToUpload.filter((course) => course.practice?.includes("Protection"));
        resilience = coursesToUpload.filter((course) => course.practice?.includes("Resilience"));
        physicalSec = coursesToUpload.filter((course) => course.practice?.includes("Physical"));

        addFilteredData(startegy, "cyberstrategy");
        addFilteredData(protection, "cyberprotection");
        addFilteredData(resilience, "cyberresilience");
        addFilteredData(physicalSec, "cyberphysicalsec");

        setLoading(false);

    }

    const handleReadFile = (e) => {

        
        const file = fileInputRef.current.files[0];
        
        if (!file) {
            alert('Please select an Excel file first.');
            return;
        }
        
        setfilename(file.name);
        
        const reader = new FileReader();
        
        reader.onload = (e) => {
            
            const binaryStr = e.target.result;
            const workbook = XLSX.read(binaryStr, { type: "array" });
            const sheetName = workbook.SheetNames[0]; // first sheet
            const sheet = workbook.Sheets[sheetName];
            const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
            // console.log("diff", e.target, "onemore",);
            console.log("json", jsonData);
            
            setalldata(convertToJSON(jsonData));
            setconfirmationPopup(true);
            // filterAndPostData(convertToJSON(jsonData));

            // setcourseToUpload(convertToJSON(jsonData));

        };

        reader.readAsArrayBuffer(file);
        e.target.value = '';
    };

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '50px' }}>
                <ClipLoader size={50} color="#123abc" loading={true} />
            </div>
        );
    }

    return (
        <>
            <div className="banner-container">
                <img src="images/Banner1.png" alt="banner" className="banner-img" />
                <MenuNavbar />
            </div>
            <Floaticons />
            <div className="ssa-container">
                <h2 className="ssa-heading">
                    Security Specialization Academy
                    {allowedPeople.includes(loggedInEnterpriseId) && (
                        <button
                            type="button"
                            onClick={handleButtonClick}
                            className="upload-specialzation"
                        >
                            <AddIcon />
                            Upload Excel
                        </button>
                    )}
                {/* <button style={{ marginLeft : "10px"}} onClick={handleButtonClick}>Upload Excel</button> */}
                <input classname="searchxl-input" ref={fileInputRef} type="file" accept=".xlsx, .xls" onChange={(e) => handleReadFile(e)} hidden/>

                </h2>
                <div className="ssa-cards-container">
                    {
                        SSAcardsData.map((item) => {
                            return (
                                <div className="ssa-card">
                                    <img src={item.tileImage} alt="ssa-tile-image" className="ssa-tile-image" />
                                    <div className="ssa-card-wrap">
                                        <h4 className="ssa-card-heading">{item.name}</h4>
                                        <p className="ssa-card-intro">{item.intro}</p>
                                        <NavLink to={item.learnMore} className='ssa-learn-more'>Learn more</NavLink>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            {/* <div>
                Data removed from Json
                {
                "name": "Cross Offerings",
                "tileImage": "images/SSA/Home/CrossOfferings.png",
                "intro": "Seamlessly integrating multiple disciplines to provide a holistic learning experience and empower with versatile skills across various domains.",
                "learnMore": "/CrossOfferingsNew"
                }
            </div> */}
            {/* Full-Screen Popup Modal */}
            {confirmationPopup && (
                <div className="fullscreen-popup">
                    <div className="popup-content">
                        <div className="questions">Are you sure you want to submit?</div>
                        <p>{filename}</p>
                        <div className="popup-buttons">
                            <button className="confirm" onClick={() => { setLoading(true); filterAndPostData(alldata); setconfirmationPopup(false); }}>Yes, submit!</button>
                            <button className="cancel" onClick={() => setconfirmationPopup(false)}>Cancel</button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default SecuritySpecialization;
